var _rect, _path, _path2, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#777E90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.38178V6.167C6 5.85647 6.25174 5.60474 6.56227 5.60474H8.84078C9.34557 5.60474 9.59465 6.21835 9.23269 6.57019L6.95417 8.78496C6.59772 9.13143 6 8.87887 6 8.38178Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.6182V17.833C19 18.1435 18.7482 18.3953 18.4377 18.3953H16.1592C15.6544 18.3953 15.4053 17.7816 15.7673 17.4298L18.0458 15.215C18.4023 14.8686 19 15.1211 19 15.6182Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.9837,
    cy: 9.62118,
    rx: 4.0162,
    ry: 4.0162,
    fill: "white",
    fillOpacity: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0162,
    cy: 14.379,
    rx: 4.0162,
    ry: 4.0162,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapDefault);
export default __webpack_public_path__ + "static/media/swap_default.02d66909fc896d65796635bc4c0b00af.svg";
export { ForwardRef as ReactComponent };